import React from "react";
import { useSlate } from "slate-react";

import Button from "./Button";
import Icon from "./Icon";

const UndoButton = () => {
  const editor = useSlate();

  const handleClick = (event) => {
    event.preventDefault();
    editor.undo();
  }

  return (
    <Button onClick={handleClick}>
      <Icon icon="undo" />
    </Button>
  );
}

export default UndoButton;
